import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import Checkbox from "@material-ui/core/Checkbox";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Helmet from "react-helmet";
import PermissionDeniedComp from "Component/PermissionDeniedComp/PermissionDeniedComp";
import headersList from "Constants/headersList";
import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import MenuItem from "@material-ui/core/MenuItem";
import Input from "@material-ui/core/Input";
import SearchIcon from "@material-ui/icons/Search";
import DrawerHeader from "Component/Headers/drawerHeader";
import Select from "@material-ui/core/Select";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import withStyles from "@material-ui/core/styles/withStyles";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import Drawer from "@material-ui/core/Drawer";
import Tooltip from "@material-ui/core/Tooltip";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import publicIp from "public-ip";
import { instance } from "../../../../../../Actions/AxiosInstance";
import {
  CheckActionPermission,
  setHelperText,
} from "../../../../../../Actions/commonAction";
import "./index.css";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    zIndex: 1,
    overflow: "hidden",
    // position: 'relative',
    display: "flex",
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
  tabheading: {
    fontSize: 16,
    textTransform: "capitalize",
    padding: 0,
  },
  button: {
    margin: theme.spacing.unit,
  },
});

function LabelValue({ label, value }) {
  return (
    <div
      className="margin-bottom-8 display-flex"
      style={{ justifyContent: "space-between" }}
    >
      <p className="t-14 normal-dark-secondary">{label}</p>
      <p className="t-14 normal-dark-secondary t-bold ellipsis width60 text-align-right">
        {value}
      </p>
    </div>
  );
}

class PermissionSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      commodityid: null,
      profileid: null,
      profile: "",
      featurelist: null,
      childfeatures: [],
      selectedaccess: null,
      isreportee: false,
      currentFeatue: null,
      saveobject: {},
      tempfeatures: [],
      permissions: { readOnly: false, editable: false },
      isshowlog: false,
      featurchangelog: [],
    };

    this.onSave = this.onSave.bind(this);
    this.getSubFeatureList = this.getSubFeatureList.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.getFeatureList = this.getFeatureList.bind(this);
    this.getDefaultActions = this.getDefaultActions.bind(this);
    this.handleChangeReportee = this.handleChangeReportee.bind(this);
    this.onProfileChange = this.onProfileChange.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.getFeatureChangeLog = this.getFeatureChangeLog.bind(this);
  }

  componentWillMount() {
    const [isTrue, permissions] = CheckActionPermission("defaultPermission");
    if (isTrue) {
      this.setState({ permissions }, () => this.getDefaultPermissions());
    } else {
      // this.props.history.push("404");
      this.setState({ permissiondenied: true });
    }
  }

  componentDidMount() {
    this.props.setHelperText({
      helperText: "Helper text regarding Permission Profile",
      open: false,
    });
    const [isTrue, permissions] = CheckActionPermission("defaultPermission");
    if (isTrue) {
      this.setState({ permissions });
    } else {
      // this.props.history.push("404");
      this.setState({ permissiondenied: true });
    }
  }

  getDefaultPermissions() {
    instance
      .get("/subscription/getallpermissionpolicy/true")
      .then((result) => {
        let permissions = [];
        result.data.result.length > 0
          ? (permissions = result.data.result)
          : (permissions = []);

        const profile =
          permissions &&
          permissions.find((profile) => profile.profilename === "Employee");
        this.setState(
          {
            profilepermisions: permissions,
            profile: "Employee",
            profileid: profile.profileid,
          },
          () => {
            this.getFeatureList();
          },
        );
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  onProfileChange(event) {
    if (event.target.value && event.target.value !== "") {
      const profiles = this.state.profilepermisions;
      const profile =
        profiles &&
        profiles.find((profile) => profile.profilename === event.target.value);
      this.setState(
        {
          profileid: profile.profileid,
          profile: event.target.value,
          featurelist: null,
          currentFeatue: null,
          selectedaccess: null,
          saveobject: null,
          commodityid: null,
          childfeatures: [],
          isreportee: false,
        },
        () => {
          this.getFeatureList();
        },
      );
    }
  }

  getFeatureList() {
    instance
      .get(`/subscription/getpermissionpolicybyid/${this.state.profileid}`)
      .then((result) => {
        this.setState({
          featurelist: result.data.result && result.data.result[0],
          saveobject: {
            featurejson: [],
            profileid: result.data.result[0].profileid,
            profilename: result.data.result[0].profilename,
            description: result.data.result[0].description,
          },
        });
      })
      .catch((error) => {
        console.log("error", error);
      });
  }

  getSubFeatureList(feature) {
    this.setState({
      commodityid: feature.commodityid,
      childfeatures: feature.feature,
      tempfeatures: feature.feature,
    });
  }

  onSearch(e) {
    const childfeatures = this.state.tempfeatures.filter(
      (item) =>
        item.featurename.toLowerCase().search(e.target.value.toLowerCase()) !==
        -1,
    );
    if (e.target.value !== "") {
      this.setState({ searchValue: e.target.value, childfeatures });
    } else {
      this.setState({
        searchValue: e.target.value,
        childfeatures: this.state.tempfeatures,
      });
    }
  }

  getDefaultActions(childfeature) {
    this.setState({
      selectedaccess: childfeature.actionid,
      currentFeatue: childfeature,
    });
  }

  handleChange(event) {
    const { saveobject } = this.state;
    const currentfeature = this.state.currentFeatue;
    delete currentfeature.actionname;
    currentfeature.actionid = parseInt(event.target.value);
    if (saveobject.featurejson && saveobject.featurejson.length > 0) {
      let flag = false;
      saveobject.featurejson.forEach((object, index) => {
        if (object.featureid === currentfeature.featureid) {
          saveobject.featurejson[index] = currentfeature;
          flag = true;
        }
      });
      if (!flag) {
        saveobject.featurejson.push(currentfeature);
      }
    } else {
      saveobject.featurejson.push(currentfeature);
    }
    this.setState({
      selectedaccess: parseInt(event.target.value),
      currentFeatue: currentfeature,
      saveobject,
    });
  }

  handleChangeReportee() {
    const { saveobject } = this.state;
    const currentfeature = this.state.currentFeatue;
    delete currentfeature.actionname;
    const isonlyreportee = !this.state.isreportee;
    currentfeature.isonlyreportee = isonlyreportee;
    if (saveobject.featurejson && saveobject.featurejson.length > 0) {
      let flag = false;
      saveobject.featurejson.forEach((object, index) => {
        if (object.featureid === currentfeature.featureid) {
          saveobject.featurejson[index] = currentfeature;
          flag = true;
        }
      });
      if (!flag) {
        saveobject.featurejson.push(currentfeature);
      }
    } else {
      saveobject.featurejson.push(currentfeature);
    }
    this.setState({
      isreportee: !this.state.isreportee,
      currentFeatue: currentfeature,
      saveobject,
    });
  }

  onSave() {
    if (
      this.state.saveobject.featurejson &&
      this.state.saveobject.featurejson.length > 0
    ) {
      publicIp
        .v4()
        .then((ipaddress) => {
          instance
            .post("/subscription/insertupdatepermissionprofile", {
              ...this.state.saveobject,
              ipaddress,
            })
            .then((result) => {
              if (result.data.result[0].isexecuted) {
                this.props.enqueueSnackbar("saved succesfully", {
                  variant: "success",
                });
              }
            })
            .catch((error) => {
              this.props.enqueueSnackbar(
                error.response
                  ? error.response.data.error.message
                  : error.message,
                { variant: "error" },
              );
              // console.log(error)
            });
        })
        .catch((error) => {
          this.props.enqueueSnackbar("IP-Address not found", {
            variant: "error",
          });
        });
    } else {
      this.props.enqueueSnackbar(
        "Please give permission to at least one feature",
        { variant: "error" },
      );
    }
  }

  getFeatureChangeLog() {
    const currentFeatureId = this.state.currentFeatue
      ? this.state.currentFeatue.featureid
      : "";
    instance
      .get(
        `/subscription/getpermissionchangelog/${this.state.profileid}/${currentFeatureId}`,
      )
      .then((result) => {
        let featurelog = [];
        featurelog = result.data.result.length > 0 ? result.data.result : [];
        this.setState({ featurchangelog: featurelog });
        this.setState({ isshowlog: true });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  render() {
    const { classes, theme } = this.props;
    const { value } = this.state;

    return (
      <IntlProvider locale="en">
        <main className="content-outer-wrapper">
          <Helmet>
            <title>{headersList.Config.DefaultPermission.header}</title>
          </Helmet>
          {this.state.permissiondenied ? (
            <div className="position-rel">
              <PermissionDeniedComp />
            </div>
          ) : (
            <div>
              <Grid container>
                <Grid item xs={12} md={12} sm={12}>
                  <div className="floatleft">
                    <span className="floatleft t-16 margin-right-8">
                      <span className="floatleft">Default Permission for</span>
                      <span
                        className="floatleft"
                        style={{ marginLeft: 4, marginTop: -6 }}
                      >
                        <Select
                          // className="selectoptions"
                          value={this.state.profile && this.state.profile}
                          onChange={this.onProfileChange}
                        >
                          <MenuItem
                            style={{ cursor: "pointer" }}
                            value="Employee"
                          >
                            Employee
                          </MenuItem>
                          <MenuItem
                            style={{ cursor: "pointer" }}
                            value="Manager"
                          >
                            Manager
                          </MenuItem>
                        </Select>
                      </span>
                    </span>
                  </div>
                  {this.state.permissions.editable && (
                    <div className="floatright">
                      <Button
                        color="primary"
                        variant="contained"
                        type="button"
                        className="margin-top-0 btn btn-primary-md-blue"
                        onClick={this.onSave}
                      >
                        Save
                      </Button>
                    </div>
                  )}
                </Grid>
                <Grid item xs={12} md={12} sm={12} className="margin-top-30">
                  <Card>
                    <div className="permission-table">
                      <div className={`dp-panel-outer width61`}>
                        <div className="dp-panel">
                          <div className="dp-panel-content">
                            <div className="dp-header">
                              <span className="dp-header-content">Product</span>
                            </div>
                            <div className="dp-data">
                              <div className="dp-data-content">
                                <List className="padding-top-0 width100">
                                  {this.state.featurelist &&
                                    this.state.featurelist.featurejson &&
                                    this.state.featurelist.featurejson.map(
                                      (feature) => (
                                        <ListItem
                                          button
                                          className={`t-16 ${
                                            this.state.commodityid ===
                                              feature.commodityid &&
                                            "mainmenu-color"
                                          }`}
                                          onClick={() =>
                                            this.getSubFeatureList(feature)
                                          }
                                          // disabled={this.state.isView = true ? false : true}
                                        >
                                          <ListItemText
                                            className={`${
                                              this.state.commodityid ===
                                                feature.commodityid &&
                                              "select-color"
                                            }`}
                                          >
                                            {feature.commodityname}
                                          </ListItemText>
                                          <ChevronRightIcon />
                                        </ListItem>
                                      ),
                                    )}
                                </List>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="dp-panel-outer">
                        <div className="dp-panel">
                          <div className="dp-panel-content">
                            <div className="dp-header">
                              <span className="dp-header-content">
                                Page / Features
                              </span>
                              <span>
                                <div>
                                  <span>
                                    <Input
                                      placeholder="Search"
                                      disableUnderline
                                      value={this.state.searchValue}
                                      fullWidth
                                      className="master-seach textback"
                                      onChange={this.onSearch}
                                      style={{ height: 35 }}
                                    />
                                  </span>
                                </div>
                              </span>
                            </div>
                            <div className="dp-data">
                              <div className="dp-data-content">
                                <List className="padding-top-0 padding-bottom-0 width100">
                                  {this.state.childfeatures &&
                                    this.state.childfeatures.map((feature) => {
                                      const Name = () => (
                                        <span className="ellipsis">
                                          {parseInt(feature.featureid) >
                                            999 && (
                                            <span
                                              className="config-text"
                                              style={{ color: "white" }}
                                            >
                                              config
                                            </span>
                                          )}{" "}
                                          {feature.featurename}
                                        </span>
                                      );
                                      return (
                                        <ListItem
                                          key="l"
                                          button
                                          className={`${
                                            this.state.currentFeatue &&
                                            this.state.currentFeatue
                                              .featureid === feature.featureid
                                              ? "mainmenu-color display-flex flex-direction-column"
                                              : "display-flex flex-direction-column "
                                          }`}
                                          onClick={() =>
                                            this.getDefaultActions(feature)
                                          }
                                        >
                                          <div className="width100">
                                            <ListItemText
                                              className={`${
                                                this.state.currentFeatue &&
                                                this.state.currentFeatue
                                                  .featureid ===
                                                  feature.featureid &&
                                                "select-color ellipsis"
                                              }`}
                                              style={{ float: "left" }}
                                            >
                                              <Name />
                                            </ListItemText>
                                            <ChevronRightIcon
                                              style={{ float: "right" }}
                                            />
                                          </div>
                                          <div
                                            style={{
                                              color: "black",
                                              width: "100%",
                                              fontSize: 11,
                                              wordBreak: "break-word",
                                              opacity: "0.7",
                                            }}
                                          >
                                            {feature.description
                                              ? feature.description
                                              : ""}
                                          </div>
                                        </ListItem>
                                      );
                                    })}
                                </List>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className={`dp-panel-outer width61`}>
                        <div className="dp-panel">
                          <div className="dp-panel-content">
                            <div className="dp-header">
                              <span className="dp-header-content">
                                Access Level
                              </span>
                            </div>
                            <div className="dp-data">
                              <div
                                className="dp-data-content"
                                style={{ marginLeft: 20 }}
                              >
                                {this.state.currentFeatue ? (
                                  <FormControl component="fieldset">
                                    <RadioGroup
                                      aria-label="Gender"
                                      name="access"
                                      value={this.state.selectedaccess}
                                      onChange={this.handleChange}
                                    >
                                      {this.state.currentFeatue &&
                                        this.state.currentFeatue
                                          .availableactionids &&
                                        this.state.currentFeatue.availableactionids.includes(
                                          "1",
                                        ) && (
                                          <FormControlLabel
                                            value={1}
                                            control={<Radio />}
                                            disabled={
                                              !this.state.permissions.editable
                                            }
                                            label="Full Access"
                                          />
                                        )}
                                      {this.state.currentFeatue &&
                                        this.state.currentFeatue
                                          .availableactionids &&
                                        this.state.currentFeatue.availableactionids.includes(
                                          "2",
                                        ) && (
                                          <FormControlLabel
                                            value={2}
                                            control={<Radio />}
                                            disabled={
                                              !this.state.permissions.editable
                                            }
                                            label="View Access"
                                          />
                                        )}
                                      {this.state.currentFeatue &&
                                        this.state.currentFeatue
                                          .availableactionids &&
                                        this.state.currentFeatue.availableactionids.includes(
                                          "3",
                                        ) && (
                                          <FormControlLabel
                                            value={3}
                                            control={<Radio />}
                                            disabled={
                                              !this.state.permissions.editable
                                            }
                                            label="Deny Access"
                                          />
                                        )}
                                    </RadioGroup>
                                  </FormControl>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="dp-panel"
                          onClick={this.getFeatureChangeLog}
                        >
                          <div className="dp-panel-content">
                            <div className="dp-header">
                              <Tooltip
                                title="Logs will be displayed for all permission changes or the selected feature."
                                placement="top"
                              >
                                <Button
                                  variant="outlined"
                                  className="btn btn-secondary-sm-blue"
                                  onClick={this.getFeatureChangeLog}
                                  style={{ marginTop: 6, marginBottom: 6 }}
                                >
                                  Change Log
                                </Button>
                              </Tooltip>
                            </div>
                          </div>
                        </div>
                      </div>
                      {this.state.profileid === "2" && (
                        <div className="dp-panel-outer width70">
                          <div className="dp-panel">
                            <div className="dp-panel-content">
                              <div className="dp-header">
                                <span className="dp-header-content">
                                  Access Limit
                                </span>
                              </div>
                              <div className="dp-data">
                                <div
                                  className="dp-data-content"
                                  style={{ marginLeft: 20 }}
                                >
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        checked={
                                          this.state.currentFeatue &&
                                          this.state.currentFeatue
                                            .isonlyreportee
                                        }
                                        onChange={this.handleChangeReportee}
                                        value={
                                          this.state.currentFeatue &&
                                          this.state.currentFeatue
                                            .isonlyreportee
                                        }
                                        disabled={
                                          !(
                                            this.state.selectedaccess === 1 ||
                                            this.state.selectedaccess === 2
                                          )
                                        }
                                      />
                                    }
                                    label="Reportee's Data"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </Card>
                </Grid>
              </Grid>
              <Drawer
                anchor="right"
                open={this.state.isshowlog}
                onClose={() => this.setState({ isshowlog: false })}
                style={{ padding: 40 }}
                classes={{
                  paper: "planner-drawer padding15 width25",
                }}
              >
                <div className="margin-bottom-24">
                  <DrawerHeader
                    header={`Feature Change Logs`}
                    isbackarrow={false}
                    closeDrawer={() =>
                      this.setState({
                        isshowlog: false,
                        currentFeatue: "",
                      })
                    }
                  />
                  {this.state.featurchangelog &&
                  this.state.featurchangelog.length > 0 ? (
                    <div>
                      {this.state.featurchangelog.map((log) => (
                        <div
                          style={{
                            backgroundColor: "#f7f8f8",
                            marginBottom: 16,
                            padding: 8,
                          }}
                        >
                          <LabelValue
                            label="Feature Name"
                            value={`${log.featurename}`}
                          />
                          <LabelValue
                            label="Action"
                            value={`${log.actionname}`}
                          />
                          <LabelValue
                            label="Changed By"
                            value={`${log.changeby}`}
                          />
                          <LabelValue
                            label="Updated Date"
                            value={`${log.updatedate}`}
                          />
                          <LabelValue
                            label="IP Address"
                            value={`${log.ipaddress}`}
                          />
                        </div>
                      ))}
                    </div>
                  ) : (
                    <p className="normal-dark-secondary">No logs available</p>
                  )}
                </div>
              </Drawer>
            </div>
          )}
        </main>
      </IntlProvider>
    );
  }
}

PermissionSettings.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setHelperText: (data) => setHelperText(data),
    },
    dispatch,
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(withSnackbar(PermissionSettings)));
